import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin: ${(props) => props.margin || "0"};
  cursor: pointer;
  position: relative;
  height: ${(props) => props.size};
  width: ${(props) => props.size};
`;

const CrenterWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const Conatiner = styled.div`
  position: absolute;
  height: 14px;
  width: 1.5px;
  margin-top: -7px;
  background-color: ${(props) => props.background || "#28476A"};
  transform: rotate(45deg);
  z-index: 1;
`;

const Md = styled.div`
  position: absolute;
  height: 14px;
  width: 1.5px;
  margin-top: -7px;
  background-color: ${(props) => props.background || "#28476A"};
  transform: rotate(-45deg);
  z-index: 2;
`;

export default function CloseIcon({ onClick, margin, background, size }) {
  return (
    <Wrapper margin={margin} onClick={onClick} size={size || "20px"}>
      <CrenterWrapper>
        <Conatiner background={background}></Conatiner>
        <Md background={background}></Md>
      </CrenterWrapper>
    </Wrapper>
  );
}
